import { ENVS, getApigeeUrl, getEnv } from '@adsk/acs-sc-web-platform-api';

/**
 * Get the base URL for the schedule BE service.
 */
export const getBaseScheduleBEUrl = () => {
  const env = getEnv();
  const schedulePath = env === ENVS.QA ? 'schedule-qa' : 'schedule';
  return `${getApigeeUrl()}/construction/${schedulePath}/v1`;
};
